<mat-chip [ngClass]="getLabelClass()" disabled><span style="color: #fff">{{ status }}</span></mat-chip>
